const _0 = "0px"
const _2 = "2px"
const _4 = "4px"
const _8 = "8px"
const _DEFAULT = "1px"
const config = { "0": _0, "2": _2, "4": _4, "8": _8, "DEFAULT": _DEFAULT,  }
export { config as default, _0, _2, _4, _8, _DEFAULT }